const authenticated_pt = require('./authenticated.json')
export default authenticated_pt